(function casaAccountAuthState(){
  var lastState = null;   // 'in' | 'out' — so we only reset the tabs on a change

  function modalEl(){ return document.getElementById('modal-account'); }
  function signedIn(){ return !!window.casaUser; }

  // Shared destinations — the guest gate below reuses these so "Become a
  // Consignor" lands in the same place from every entry point.
  window.casaGoShop = function(){
    try { if (typeof closeModal === 'function') closeModal('account'); } catch(e){}
    try { if (typeof switchView === 'function') switchView('shop'); } catch(e){}
  };
  window.casaGoConsign = function(){
    try { if (typeof closeModal === 'function') closeModal('account'); } catch(e){}
    try { if (typeof switchView === 'function') switchView('sell'); } catch(e){}
    // The consignment request form is the point of the page, not the top of it.
    setTimeout(function(){
      try {
        var f = document.querySelector('#view-sell .sell-form-wrap');
        if (f && f.scrollIntoView) f.scrollIntoView({ behavior: 'smooth', block: 'start' });
      } catch(e){}
    }, 140);
  };

  // ---- Sign Out ---------------------------------------------------------
  function signOutBtn(create){
    var m = modalEl(); if (!m) return null;
    var b = m.querySelector('.casa-signout');
    if (b || !create) return b;
    var host = m.querySelector('.modal'); if (!host) return null;
    b = document.createElement('button');
    b.className = 'btn btn-ghost btn-block btn-sm casa-signout';
    b.type = 'button';
    b.style.marginTop = '18px';
    b.textContent = 'Sign Out';
    b.onclick = function(){
      try { if (typeof closeModal === 'function') closeModal('account'); } catch(e){}
      if (typeof window.casaLogout === 'function') window.casaLogout();
    };
    host.appendChild(b);
    return b;
  }

  // The Sell page's "Already registered? Sign in" is the one other place the
  // words appear to a customer who is already signed in.
  function sellCtaSignin(){
    var out = [];
    try {
      document.querySelectorAll('.seller-cta button[onclick]').forEach(function(el){
        if ((el.getAttribute('onclick') || '').indexOf("switchTabByName('signin')") >= 0) out.push(el);
      });
    } catch(e){}
    return out;
  }

  function render(){
    var m = modalEl(); if (!m) return;
    var inSession = signedIn();
    var tabSignin = m.querySelector('.tab-row button[data-tab="signin"]');
    var panels = ['tab-signin', 'tab-register', 'tab-consignor'].map(function(id){
      return document.getElementById(id);
    });
    // Any auth surface that sits OUTSIDE the tab panels has to be hidden
    // separately — hiding the panels alone is not enough. The Google/Apple block
    // that used to live here was removed (dead controls, no SDK), but the lookup
    // is kept and null-guarded so re-adding one cannot silently leave it showing
    // to a customer who is already signed in.
    var social = [m.querySelector('.auth-divider'), m.querySelector('.social-auth')];

    if (inSession) {
      if (tabSignin) { tabSignin.style.display = 'none'; tabSignin.classList.remove('active'); }
      // No credential form belongs in front of someone who already has a session.
      // Except the seller signup's own confirmation: #consignor-success lives inside
      // #tab-consignor, so hiding that panel the moment the new account's session
      // appears swallowed "Welcome to the consignor family" (found 23 Sep 2026). Its
      // form is already hidden by the signup handler, so only the message remains.
      var sellerDone = document.getElementById('consignor-success');
      sellerDone = !!(sellerDone && sellerDone.style.display === 'block');
      panels.forEach(function(p){
        if (!p) return;
        p.style.display = (sellerDone && p.id === 'tab-consignor') ? 'block' : 'none';
      });
      social.forEach(function(p){ if (p) p.style.display = 'none'; });
      // switchTab() rewrites the heading per tab and only the storefront's own
      // updateAccountUI() puts it back — and that one is closed over inside its
      // IIFE, so it never runs on open. Without this the modal reopens still
      // captioned "Become a Consignor · Submit pieces and earn up to 80%" from
      // whatever tab was last touched.
      var t = document.getElementById('account-title'), s = document.getElementById('account-sub');
      if (t) t.textContent = 'Welcome back';
      if (s) s.textContent = 'Signed in as ' + (window.casaUser.email || '');
      signOutBtn(true);
      sellCtaSignin().forEach(function(el){ el.style.display = 'none'; });
    } else {
      if (tabSignin) tabSignin.style.display = '';
      social.forEach(function(p){ if (p) p.style.display = ''; });
      var b = signOutBtn(false); if (b && b.parentNode) b.parentNode.removeChild(b);
      sellCtaSignin().forEach(function(el){ el.style.display = ''; });
      // Only on the signed-in → signed-out transition, or we would fight a
      // visitor who has deliberately clicked over to Shop With Us.
      if (lastState === 'in') {
        try { if (typeof switchTabByName === 'function') switchTabByName('signin'); } catch(e){}
      }
    }
    lastState = inSession ? 'in' : 'out';
  }

  // ---- Re-point the two remaining tabs while signed in -------------------
  // Capture phase, so this runs before the button's own inline switchTab().
  document.addEventListener('click', function(e){
    if (!signedIn()) return;
    var btn = e.target && e.target.closest ? e.target.closest('#modal-account .tab-row button') : null;
    if (!btn) return;
    var tab = btn.getAttribute('data-tab');
    if (tab !== 'register' && tab !== 'consignor') return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    if (tab === 'register') window.casaGoShop();
    else window.casaGoConsign();
  }, true);

  // casaUser is filled in by an async /auth/me, and sign-in / sign-out change
  // it without any event we own. Same approach the orders panel already uses:
  // watch the modal, and poll lightly while it is open.
  try {
    var mo = modalEl();
    if (mo) new MutationObserver(render).observe(mo, { attributes: true, attributeFilter: ['class'] });
  } catch(e){}
  setInterval(function(){
    var m = modalEl();
    // Cheap when closed — the Sell-page CTA still has to track the session.
    if (m && m.classList.contains('open')) render();
    else if ((signedIn() ? 'in' : 'out') !== lastState) render();
  }, 700);
  render();
  setTimeout(render, 900); setTimeout(render, 2400);

  console.log('%cCASA · Account modal is auth-aware', 'background:#141414;color:#fff;padding:4px 10px;font-weight:bold;');
  console.log('  ✓ Signed in: Sign In tab hidden, Shop With Us / Become a Consignor act, Sign Out available');
})();
